// extracted by mini-css-extract-plugin
module.exports = {"card-title-container":"CardTitle_card-title-container__2L7QD","icon-container":"CardTitle_icon-container__1oRSa","icon":"CardTitle_icon__Of_OT"};